// src/hooks/useHosted.ts
import useSWR from "swr";
import { fetcher } from "../config/axiosConfig.ts";
import { swrOptions } from "../const.ts";

export interface HostedEvent {
  idEvent: string;
  coverPhoto: string;
  eventName: string;
  ticketType: "FREE" | "PAID" | "OTHER";
  ticketCost: number | null;
  attendanceTypeEnum: "ONLINE" | "OFFLINE";
  startDate: string;
  endDate?: string | null;
  startTime: string;
  endTime?: string | null;
  duration?: number | null;
  address?: string | null;
  viewCount: string;
  usersList: {
    goingCount: number;
    interestedCount: number;
    expectedCount: number;
  };
}

export interface HostedResponse {
  body: HostedEvent[];
}

export function useHosted() {
  const {
    data: active,
    error: activeError,
    isLoading: isActiveLoading,
  } = useSWR<HostedResponse>(
      "recommended-ms/host-active",
      fetcher,
      swrOptions
  );

  const {
    data: past,
    error: pastError,
    isLoading: isPastLoading,
  } = useSWR<HostedResponse>(
      "recommended-ms/host-past",
      fetcher,
      swrOptions
  );

  return {
    active,
    past,
    isLoading: isActiveLoading || isPastLoading,
    error: activeError || pastError,
  };
}
